<template>
  <div class="MarketCategory">
    <div class="info">
      <i class="el-icon-warning"></i>
      <p>Category is for managing products of different categories.</p>
    </div>
    <table class="table">
      <thead class="head">
      <tr>
        <th class="head_item" style="width: 40px">Sort</th>
        <th class="head_item" style="width: 200px">Category Name</th>
        <th class="head_item" style="min-width: 60px">Count</th>
        <th class="head_item"></th>
      </tr>
      </thead>
      <tbody class="body">
      <template v-if="category_list.length!==0">
        <tr class="body_row" v-for="(category,index) in category_list" :key="category.pro_category_id">
          <td class="body_item">
            <div style="display: flex;flex-direction: column;align-items: center">
              <el-button class="arrow" :disabled="index===0" icon="el-icon-arrow-up"
                         @click="onOrderChange(index,'up')"></el-button>
              <p>{{category.order}}</p>
              <el-button class="arrow" :disabled="index===category_list.length-1" icon="el-icon-arrow-down"
                         @click="onOrderChange(index,'down')"></el-button>
            </div>
          </td>

          <td class="body_item">
            <p>{{category.pro_category_name_en}}<br>{{category.pro_category_name_cn}}</p>
          </td>
          <td class="body_item">
            {{category.product_count}}
          </td>

          <td class="body_item">
            <el-button class="action" type="primary" size="mini"
                       @click="onEdit(category.pro_category_name_en,category.pro_category_name_cn,category.pro_category_id)">
              Edit
            </el-button>
            <el-button class="action" type="danger" size="mini" @click="onDelete(category.pro_category_id)">Delete
            </el-button>
          </td>
        </tr>
      </template>
      <template v-if="category_list.length===0&&category_list!==false">
        <tr class="body_row">
          <td class="body_item">

          </td>
          <td class="body_item no_option">
            No Category
          </td>
        </tr>
      </template>
      </tbody>
    </table>
    <el-button @click="dialog_visible = true" class="add" type="primary" size="medium" round="" icon="el-icon-plus">
      Create Category
    </el-button>
    <el-button v-if="category_list.length>=2" @click="onSortSave" class="add" size="medium" round="">
      Save sorting order
    </el-button>

    <el-dialog width="30%" style="min-width: 1400px" title="Edit Category Name" :visible.sync="dialog_visible">
      <el-form v-if="dialog_visible" :model="item_holder" :rules="rules" ref="nameForm">
        <el-form-item label="EN Name" label-width="100px" prop="name_en">
          <el-input v-model="item_holder.name_en" style="width: 200px" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="CN Name" label-width="100px" prop="name_cn">
          <el-input v-model="item_holder.name_cn" style="width: 200px" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onNameSave(item_holder.name_en,item_holder.name_cn,item_holder.id)">Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {deleteProductCategory, getProductCategory, orderProductCategory, saveProductCategoryName} from "@/utils/api";
  import {adjustArrayOrder} from "@/utils/util";

  export default {
    props: {},
    data: () => {
      return {
        item_holder: {
          name_en: '',
          name_cn: '',
          id: ''
        },
        dialog_visible: false,
        category_list: false,
        rules: {
          name_en: [
            {required: true, message: 'English name is required', trigger: 'blur'},
          ],
          name_cn: [
            {required: true, message: 'Chinese name is required', trigger: 'blur'},
          ],
        }
      }
    },
    watch: {
      dialog_visible: function (n) {
        if (!n) {
          this.item_holder = {
            name_en: '',
            name_cn: '',
            id: ''
          };
          getProductCategory().then(res => {
            this.category_list = res.category_list
          })
        }
      }
    },
    methods: {

      onSortSave() {
        this.$showLoading('Updating');
        orderProductCategory(this.category_list).then(res => {
          this.$hideLoading();
          if (res.errcode === 0) {
            this.$message.success('Sorting order updated');
            getProductCategory().then(res => {
              this.category_list = res.category_list
            })
          } else {
            this.$message.error('Error');
          }
        })
      },
      onOrderChange(index, type) {
        this.category_list = adjustArrayOrder(index, this.category_list, type)
      },
      onNameSave(name_en, name_cn, id) {
        this.$refs['nameForm'].validate((valid) => {
          if (valid) {
            saveProductCategoryName(name_en, name_cn, id).then(res => {
              if (res.errcode === 0) {
                this.$message.success(`Category ${id===''?'created':'saved'}`);
              } else {
                this.$message.error('Error');
              }
              this.dialog_visible = false
            })
          } else {
            this.$message.error('Check your inputs');
            return false;
          }
        });

      },

      onEdit(name_en, name_cn, id) {
        this.item_holder = {
          name_en: name_en,
          name_cn: name_cn,
          id: id
        };
        this.dialog_visible = true
      },

      onDelete(id) {
        this.$confirm(`Are you sure to delete this category? Products under it will reset their category tag to default`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          deleteProductCategory(id).then(res => {
            if (res.errcode === 0) {
              this.$message.success('Category deleted');
              getProductCategory().then(res => {
                this.category_list = res.category_list
              })
            } else {
              this.$message.error('Error');
            }
          })
        }).catch(() => {
        });
      },
    },
    beforeMount() {
      getProductCategory().then(res => {
        this.category_list = res.category_list
      })
    }
  };

</script>

<style lang="scss" scoped>
  @import "_MarketCategory.scss";
</style>